import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import { X } from "lucide-react";
import { thanks, TIKTOK_URL } from "@/content/copy";
import { Owl } from "./primitives";

const ease = [0.22, 1, 0.36, 1];

const isTipReturn = () => {
  const p = new URLSearchParams(window.location.search);
  return p.get("tip") === "thanks" || p.has("session_id");
};

export const TipThanks = () => {
  const [show, setShow] = useState(isTipReturn);
  const closeRef = useRef(null);

  useEffect(() => {
    if (!show) return undefined;
    closeRef.current?.focus();
    document.body.style.overflow = "hidden";
    const onKey = (e) => { if (e.key === "Escape") setShow(false); };
    window.addEventListener("keydown", onKey);
    return () => { document.body.style.overflow = ""; window.removeEventListener("keydown", onKey); };
  }, [show]);

  useEffect(() => {
    if (show || !isTipReturn()) return;
    window.history.replaceState({}, "", window.location.pathname);
  }, [show]);

  if (!show) return null;
  return (
    <div data-testid="tip-thanks-overlay" className="fixed inset-0 z-[70] flex items-end sm:items-center justify-center p-4 sm:p-8" role="dialog" aria-modal="true" aria-labelledby="tip-thanks-title">
      <motion.div className="absolute inset-0 bg-[#0d2a99]/70" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.4 }} onClick={() => setShow(false)} aria-hidden="true" />
      <motion.div className="ph-thanks relative" initial={{ opacity: 0, y: 32, scale: 0.97 }} animate={{ opacity: 1, y: 0, scale: 1 }} transition={{ duration: 0.6, ease }}>
        <button type="button" ref={closeRef} onClick={() => setShow(false)} aria-label="Close thank-you message" data-testid="tip-thanks-close" className="absolute top-4 right-4 w-11 h-11 grid place-items-center rounded-full border border-[var(--blue)]/30">
          <X size={20} />
        </button>
        <div className="w-24 h-24 sm:w-28 sm:h-28 rounded-full bg-[var(--blue)] p-4 mx-auto" aria-hidden="true"><Owl alt="" className="w-full h-full object-contain" /></div>
        <h2 id="tip-thanks-title" data-testid="tip-thanks-title" className="ph-display text-center mt-6" style={{ fontSize: "clamp(2rem, 8vw, 3.5rem)" }}>{thanks.heading}</h2>
        <p className="ph-body text-center mt-5" data-testid="tip-thanks-body">{thanks.body}</p>
        <div className="flex justify-center mt-8">
          <button type="button" onClick={() => setShow(false)} data-testid="tip-thanks-dismiss" className="ph-btn ph-btn-ink">{thanks.button}</button>
        </div>
        <p data-testid="tip-thanks-tiktok" className="ph-thanks-tiktok">
          {thanks.tiktokPre}{" "}
          <a href={TIKTOK_URL} target="_blank" rel="noopener noreferrer" data-testid="tip-thanks-tiktok-link">@philosophiles<span className="sr-only"> (opens TikTok in a new tab)</span></a>
        </p>
      </motion.div>
    </div>
  );
};
